import { FC, useCallback } from 'react';
import MagnifyIcon from './assets/magnifying_glass.svg';
import QuestionCircle from './assets/question_circle.svg';
import { ClickPosition } from '~/utils/click-position';
import { $AIOverviewInfoModalShow } from '../../atoms';
import { useSetAtom } from 'jotai';
import { useViewTracking } from '~/utils/use-view-tracking';
import { ModuleType } from '~/utils/module-type';
import { useTranslation } from 'react-i18next';

import './style.scss';

export const AIOverviewInfo: FC = () => {
  const { t } = useTranslation();
  const setModalShow = useSetAtom($AIOverviewInfoModalShow);
  const questionDisclaimerRef = useViewTracking({
    onView: useCallback(() => {
      window.Tea('wap_cta_show', {
        current_page_module: ModuleType.experience_content,
        current_position: ClickPosition.disclaimer,
      });
    }, []),
  });
  const handleClick = useCallback(() => {
    window.Tea('wap_click', {
      current_page_module: ModuleType.experience_content,
      current_position: ClickPosition.disclaimer,
    });
    setModalShow({
      currentPageModule: ModuleType.experience_content,
      currentPosition: ClickPosition.disclaimer,
    });
  }, []);
  return (
    <div className="ai-overview-container">
      <div className="ai-overview-info">
        <div className="ai-overview-tag">
          <div className="ai-overview-tag-icon">
            <MagnifyIcon />
          </div>
          <div className="ai-overview-tag-text">{t('seo_searchCard_title')}</div>
        </div>
        <div className="ai-overview-question-icon" ref={questionDisclaimerRef} onClick={handleClick}>
          <QuestionCircle />
        </div>
      </div>
      <div className="ai-overview-desc">{t('seo_searchCard_desc')}</div>
    </div>
  );
};
